import React, { useEffect, useState, useRef, useCallback } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import InfoIcon from "../support_files/InfoIcon";
import HelpIcon from "../support_files/HelpIcon";
import ToggleButton from '@mui/material/ToggleButton';

import CakeIcon from '@mui/icons-material/Cake';
import CancelIcon from '@mui/icons-material/Cancel';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import TocIcon from '@mui/icons-material/Toc';
import SourceIcon from '@mui/icons-material/Source';

import Fade from '@mui/material/Fade';

import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

import { ResponsiveBar } from '@nivo/bar'
import { ResponsiveLine } from '@nivo/line'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import ageInfoData from "../info_data/ageInfoData.json"


import { createTheme, ThemeProvider } from '@mui/material/styles';

import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


export default function AgeInfoDrawer({
  selectedInfo, setSelectedInfo,
}) {

    // Use ref to directly manipulate DOM classes - no re-renders
    const headerRef = useRef(null);
    const handleScroll = useCallback((event) => {
      const scrollTop = event.target.scrollTop;
      if (headerRef.current) {
        if (scrollTop > 20) {
          headerRef.current.classList.add('header-translucent');
          headerRef.current.classList.remove('header-solid');
        } else {
          headerRef.current.classList.add('header-solid');
          headerRef.current.classList.remove('header-translucent');
        }
      }
    }, []); // Empty dependency array since we're using refs


  const BarChart = () => {

  return (
    <div style={{ height: 400, width: '100%', position: 'relative' }}>
      {/* Centered Gender Labels */}
      <div style={{
        position: 'absolute',
        top: '10px',
        left: '60%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '20px',
        zIndex: 10
      }}>
               <div style={{
          color: '#ff9b69',
          fontSize: '14px',
          fontWeight: 'bold'
        }}>
          Women
        </div>
        <div style={{
          color: '#3dbce3',
          fontSize: '14px',
          fontWeight: 'bold'
        }}>
          Men
        </div>
      </div>
      
      <ResponsiveBar
        data={ageInfoData}
        keys={['female','male']}
        indexBy="ageGroup"
        layout="horizontal"
        margin={{ top: 40, right: 0, bottom: 50, left: 55 }}
        padding={0.1}
        valueScale={{ type: 'linear', min: -15, max: 14 }}
        indexScale={{ type: 'band', round: true }}
        colors={['#ff9b69', '#3dbce3']}
        borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        axisLeft={{
          tickSize: 0,
          tickPadding: 5,
          tickRotation: 0,
          legend: '',
          legendPosition: 'middle',
          legendOffset: 0,
          format: value => `${value} yrs`
        }}
        enableLabel={true}
        label={({ value }) => `${Math.abs(value).toFixed(1)}%`}
        labelSkipWidth={0}
        labelSkipHeight={0}
        labelTextColor="#ffffff"
tooltip={({ indexValue, value, color, data }) => {
  // Find the specific age group data
  const ageGroupData = ageInfoData.find(item => item.ageGroup === indexValue);
  const isFemale = value < 0; // Since female values are negative
  const count = isFemale ? ageGroupData.femaleCount : ageGroupData.maleCount;
  const formattedCount = count.toLocaleString();
          
          return (
            <div
              style={{
                background: 'rgba(0, 0, 0, 0.8)',
                color: '#ffffff',
                fontSize: '14px',
                borderRadius: '4px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                padding: '8px 12px',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: color,
                  marginRight: '8px',
                  borderRadius: '2px'
                }}
              />
              {formattedCount}
            </div>
          );
        }}
        theme={{
          background: 'transparent',
          text: {
            fill: '#ffffff',
            fontSize: 11
          },
          axis: {
            domain: {
              line: {
                stroke: '#777777',
                strokeWidth: 1
              }
            },
            legend: {
              text: {
                fill: '#ffffff',
                fontSize: 12
              }
            },
            ticks: {
              line: {
                stroke: '#777777',
                strokeWidth: 1
              },
              text: {
                fill: '#ffffff',
                fontSize: 11
              }
            }
          },
          grid: {
            line: {
              stroke: '#444444',
              strokeWidth: 1
            }
          }
        }}
        animate={true}
        motionConfig="gentle"
      />
    </div>
  );
};

 const AgeTable = () => {
  const handleTouchStart = (e) => {
    // Touch handling logic if needed
  };

  const handleTouchMove = (e) => {
    // Touch handling logic if needed
  };

  return (
    <TableContainer
      component={Paper}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      sx={{
        overflow: 'auto',
        marginBottom: '140px',
        borderRadius: '12px',
        backgroundColor: '#1a1a1a',
        '& .MuiTable-root': {
          '& .MuiTableCell-root': {
            color: 'white',
            borderBottom: '1px solid #444'
          },
          '& .MuiTableRow-root:hover': {
            backgroundColor: '#333'
          }
        }
      }}
    >
      <Table sx={{ maxWidth: 800 }} size="small" aria-label="demographics table">
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                position: 'sticky',
                left: 0,
                backgroundColor: '#2d2d2d',
                zIndex: 1,
                boxShadow: '2px 0 5px rgba(0,0,0,0.1)'
              }}
            >
              Age Group
            </TableCell>
            <TableCell align="right" sx={{ width: '100px', lineHeight: '15px' }}>
              Women %
            </TableCell>
            <TableCell align="right" sx={{ width: '100px', lineHeight: '15px' }}>
              Men %
            </TableCell>
                        <TableCell align="right" sx={{ width: '100px', lineHeight: '15px' }}>
              Women Count
            </TableCell>
            <TableCell align="right" sx={{ width: '100px', lineHeight: '15px' }}>
              Men Count
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ageInfoData.slice().reverse().map((item) => (
            <TableRow
              key={item.ageGroup}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{
                  width: '100px',
                  position: 'sticky',
                  left: 0,
                  backgroundColor: '#2d2d2d',
                  zIndex: 1,
                  boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
                  fontWeight: 500,
                  padding: '6px 10px 6px 10px',
                     whiteSpace: 'nowrap'
                }}
              >
                {item.ageGroup} yrs
              </TableCell>
                            <TableCell align="right" sx={{ width: '100px' }}>
                {Math.abs(item.female).toFixed(1)}%
              </TableCell>
              <TableCell align="right" sx={{ width: '100px' }}>
                {Math.abs(item.male).toFixed(1)}%
              </TableCell>
              <TableCell align="right" sx={{ width: '100px' }}>
                {item.femaleCount.toLocaleString()}
              </TableCell>
              <TableCell align="right" sx={{ width: '100px' }}>
                {item.maleCount.toLocaleString()}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};


  const drawerContent = () => (
    <div className="drawer-container" style={{ overflow: 'auto' }} onScroll={handleScroll}>
      <div ref={headerRef} className="sticky-header header-solid">
        <div className="header-content">
          <div className="header-left">
            <CakeIcon />
            <h2 className="header-title">Age</h2>
          </div>
          <div className="header-right">
            <button
              onClick={() => { setSelectedInfo(false) }}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <CancelIcon sx={{ fill: "#b4b4b4ff", fontSize: "28px" }} />
            </button>
          </div>
        </div>
      </div>

      <div className="main-content">

        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <InsertChartIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Summary</h3>
            </div>
            <div style={{height: '360px'}}>
              <BarChart />
            </div>


            <p className="card-text">
              This chart illustrates the gender distribution by age of the adult population in New York City as of 2023 according to the US Census¹.
            </p>
          </div>
        </div>


        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <TocIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Details</h3>
            </div>
           <div className="visual-container">

                <div className="section-header" style={{justifyContent: "center" }}>
                </div>
                <div style={{height: '360px'}}>
                                <AgeTable />
                </div>
            </div>
          </div>
        </div>


        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <SourceIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Source</h3>
            </div>
            <div className="visual-container">

            </div>
            <p className="card-text">
              [1] U.S. Census Bureau, 2023 American Community Survey (NYC - S0101)
            </p>
          </div>
        </div>




      </div>
    </div>
  );


  return (
    <div>
      <SwipeableDrawer
        anchor="bottom"
        open={selectedInfo}
        onClose={() => setSelectedInfo(false)}
        onOpen={() => setSelectedInfo(true)}
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: '#071c34ff',
            color: "white",
            borderTopRightRadius: '25px 15px',
            borderTopLeftRadius: '25px 15px',
            height: 'calc(100dvh - 95px)',
            overflow: 'auto'


          },
        }}
      >
        <div className="additionalInfoContainer">
          {drawerContent()}
        </div>
      </SwipeableDrawer>
    </div>
  )
}
